import { createMultiStyleConfigHelpers } from '@chakra-ui/react'
import { asChakraVariable } from '~/themes/colors/colors'
import { useCustomMultiStyleConfig } from '~/utils/chakraUtils'
import { getName } from '~/utils/objectUtils'

import { phoneColorKeys } from './_colors'

const colors = phoneColorKeys.Phone.FeedbackToast

const feedbackToastStyleParts = [
  'container',
  'header',
  'message',
  'button',
] as const

const helpers = createMultiStyleConfigHelpers(feedbackToastStyleParts)

export const FeedbackToastStyle = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      border: '1px solid',
      borderColor: colors.container.border,
      borderRadius: '0.5rem',
      gap: '0.75rem',
      padding: '0.75rem',
      boxShadow: `0px 0.267rem 0.5rem 0px ${asChakraVariable(colors.container.boxShadow)}`,
      backgroundColor: colors.container.background,
      flexDirection: 'column',
    },
    header: {
      fontWeight: '700',
      fontSize: '0.75rem',
      color: colors.header.fontColor,
      alignItems: 'center',
    },
    message: {
      justifyContent: 'center',
      fontWeight: '400',
      fontSize: '1rem',
      color: colors.message.fontColor,
      gap: '0.333rem',
    },
  },
})

const themeKey = getName({ FeedbackToastStyle })
export const useFeedbackToastStyle = () =>
  useCustomMultiStyleConfig<typeof feedbackToastStyleParts>(themeKey)
